import { POLLING_INTERVAL_SECONDS, type TrackingAdapterSummary, type TrackingIntegration } from '@chukua/common';
import { initialConfigValues, type ConfigFormValues } from '../../../policies/config-form-values.policy';

/** An install starts from the adapter's name and the default interval; an edit from what is saved. */
export function integrationFormInitialValues(adapter: TrackingAdapterSummary, saved: TrackingIntegration | undefined): ConfigFormValues {
  return {
    displayName: saved?.displayName ?? adapter.displayName,
    pollingIntervalSeconds: saved?.pollingIntervalSeconds ?? POLLING_INTERVAL_SECONDS.default,
    ...initialConfigValues(adapter.fields, saved?.config ?? {}),
  };
}
